export default {
  picker: 'https://static.filestackapi.com/picker/v3/picker-0.9.7.js',
};
